module.exports = __webpack_public_path__ + "09c21253a2d75c86856edde25cd2760a.MP3";